import React, { forwardRef, useId } from 'react';
import Field, { inputClass, describedBy } from './Field';

/**
 * Plain text input compatible with react-hook-form's register():
 *   <TextInput label="First name" {...register('firstName')} error={errors.firstName?.message} />
 */
const TextInput = forwardRef(({
  label,
  hint,
  error,
  required,
  optionalLabel,
  className,
  inputClassName = '',
  id: idProp,
  name,
  leftIcon: LeftIcon,
  ...rest
}, ref) => {
  const generatedId = useId();
  const id = idProp || `${name || 'input'}-${generatedId}`;

  return (
    <Field id={id} label={label} hint={hint} error={error} required={required} optionalLabel={optionalLabel} className={className}>
      <div className="relative">
        {LeftIcon && (
          <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            <LeftIcon className="h-4 w-4 text-gray-400" aria-hidden="true" />
          </div>
        )}
        <input
          ref={ref}
          id={id}
          name={name}
          aria-invalid={error ? 'true' : undefined}
          aria-describedby={describedBy(id, { hint, error })}
          aria-required={required || undefined}
          className={inputClass(Boolean(error), `${LeftIcon ? 'pl-10' : ''} ${inputClassName}`)}
          {...rest}
        />
      </div>
    </Field>
  );
});

TextInput.displayName = 'TextInput';

export default TextInput;
